import {
  GET_EXIST_STAFF_USER_MANAGEMENT_SUCCESS,
  GET_EXIST_STAFF_USER_MANAGEMENT_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_EXIST_STAFF_USER_MANAGEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_EXIST_STAFF_USER_MANAGEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
